import { StringMatchOperator } from "@redotech/redo-model/advanced-flow/expressions/text-expression";
import { stringMatchOperatorToLabel } from "@redotech/redo-model/advanced-flow/oms/conditions";
import { Text } from "@redotech/redo-web/text";

export function StringMatchDetails({
  field,
  matchType,
  matchValue,
}: {
  field: string;
  matchType?: StringMatchOperator;
  matchValue?: string;
}) {
  return (
    <>
      <Text fontWeight="semibold">{field}</Text>{" "}
      <Text>
        {matchType ? ` ${stringMatchOperatorToLabel[matchType]} ` : undefined}
      </Text>{" "}
      <Text
        fontWeight="semibold"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        "{matchValue}"
      </Text>
    </>
  );
}
